import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const getUserTimezone: UseCase<AuthRepository, 'getUserTimezone'> = repository => {
  return async userId => {
    return await repository.getUserTimezone(userId)
  }
}
